// import { Slider } from 'antd';
// import type { SliderSingleProps } from 'antd';
import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import Weighing_Lottie from "../../animation/Weighing_Lottie/Weighing_Lottie";
import RedRoundBtn from "../Common_Btn/RedRoundBtn/RedRoundBtn";
import "./Calculate_Personal_Loan_Emi.css";
import { useNavigate } from "react-router-dom";
import { Slider } from "@mui/material";

const Calculate_Personal_Loan_Emi = (props) => {
  const [showReset, setShowReset] = useState(false);

  console.log("showReset", showReset);

  // const marks: SliderSingleProps['marks'] = {
  //     0: '₹ 5K',
  //     100: '₹ 5L',
  // };

  const marks = [
    {
      value: 0,
      label: "₹ 5K",
    },
    {
      value: 100,
      label: "₹ 5L",
    },
  ];

  function valuetext(value: number) {
    return `${value}°C`;
  }

  const navigate = useNavigate();

  const [netIncome, setNetIncome] = useState(5000);
  const [yearlyIncome, setYearlyIncome] = useState(50000);
  const [existingEMI, setExistingEMI] = useState(5000);
  const [loanTenure, setLoanTenure] = useState(5);
  const [interestRate, setInterestRate] = useState(12);
  const [emi, setEmi] = useState(0);
  const [loanAmount, setLoanAmount] = useState(0);
  const [totalPayable, setTotalPayable] = useState(0);
  const [totalInterestPayable, setTotalInterestPayable] = useState(0);

  console.log(loanTenure, "loanTenure loanTenure");

  const calculateLoan = () => {
    // Determine how much income is available for EMI payments
    const eligibleEMI = netIncome - existingEMI + yearlyIncome / 12;
    console.log(eligibleEMI, "eligibleEMI eligibleEMI");

    if (eligibleEMI <= 0) {
      alert("Your eligible EMI is too low to get a loan.");
      return;
    }

    // Convert annual interest rate to monthly rate
    const r = interestRate / 12 / 100;
    // Total number of months
    const n = loanTenure * 12;

    // EMI Formula: E = [P * r * (1 + r)^n] / [(1 + r)^n - 1]
    const factor = Math.pow(1 + r, n);

    // Loan Amount Calculation: P = [E * ((1 + r)^n - 1)] / [r * (1 + r)^n]
    const loanAmt = (eligibleEMI * (factor - 1)) / (r * factor);

    // EMI Calculation: E = [P * r * (1 + r)^n] / [(1 + r)^n - 1]
    const calculatedEMI = (loanAmt * r * factor) / (factor - 1);

    // Total Interest = (Total EMI Payments - Loan Amount)
    const totalInterest = calculatedEMI * n - loanAmt;
    const totalAmt = loanAmt + totalInterest;

    // Update the state variables
    setTotalInterestPayable(Math.round(totalInterest));
    setLoanAmount(Math.round(loanAmt));
    setEmi(Math.round(calculatedEMI));
    setTotalPayable(Math.round(totalAmt));
  };

  const formatValue = (value) => {
    if (value >= 100000) {
      return `₹ ${(value / 100000).toFixed(1)}L`; // Convert to Lakhs (L)
    } else if (value >= 1000) {
      return `₹ ${(value / 1000).toFixed(1)}K`; // Convert to Thousands (K)
    }
    return `₹ ${value}`; // Return as-is if less than 1K
  };
  const yearMarks = [
    {
      value: 0,
      label: "0 Yrs",
    },
    {
      value: loanTenure,
      label: `${loanTenure} Yrs`,
    },
  ].map((mark) => ({ ...mark, value: Number(mark.value) }));

  const yearlyIncomemark = [
    {
      value: 0,
      label: "₹ 0",
    },
    {
      value: yearlyIncome,
      label: `₹ ${yearlyIncome}`,
    },
  ].map((mark) => ({ ...mark, value: Number(mark.value) }));

  const netIncomemark = [
    {
      value: 0,
      label: "₹ 0",
    },
    {
      value: netIncome,
      label: `₹ ${netIncome}`,
    },
  ].map((mark) => ({ ...mark, value: Number(mark.value) }));

  const exstingIncomemark = [
    {
      value: 0,
      label: "₹ 0",
    },
    {
      value: existingEMI,
      label: `₹ ${existingEMI}`,
    },
  ].map((mark) => ({ ...mark, value: Number(mark.value) }));

  const rateInterestMark = [
    {
      value: 0,
      label: "₹ 0",
    },
    {
      value: interestRate,
      label: `₹ ${interestRate}`,
    },
  ].map((mark) => ({ ...mark, value: Number(mark.value) }));

  console.log(loanTenure, "loanTenure");
  console.log(yearlyIncomemark, "yearlyIncomemark yearMarks");

  console.log(props.navigate, "props.navigate");

  return (
    <section className="Calculate_Personal_Loan_Emi">
      <div className="container">
        <p className="section_heading">{props?.heading}</p>

        <div className="main_content_div">
          <div className="row">
            <div className="col-lg-6">
              <div className="caluculator_main_div">
                <div className="slider_main_div">
                  <div className="top_part_div">
                    <div className="left_side_div">
                      <p className="text">Net income / month</p>
                    </div>
                    <div className="right_side_div">
                      <InputGroup size="sm">
                        <Form.Control
                          type="number"
                          value={netIncome}
                          onChange={(e) => setNetIncome(Number(e.target.value))}
                        />
                        <InputGroup.Text id="inputGroup-sizing-sm">
                          ₹{netIncome}
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                  </div>
                  <div className="slider_div">
                    <Slider
                      value={netIncome}
                      onChange={(e, value) => setNetIncome(value)}
                      min={0}
                      marks={netIncomemark}
                      max={50000}
                      step={1000}
                      valueLabelDisplay="auto"
                    />
                  </div>
                </div>

                <div className="slider_main_div">
                  <div className="top_part_div">
                    <div className="left_side_div">
                      <p className="text">Other yearly income</p>
                    </div>
                    <div className="right_side_div">
                      <InputGroup size="sm">
                        <Form.Control
                          aria-label="Small"
                          value={yearlyIncome}
                          type="type"
                          aria-describedby="inputGroup-sizing-sm"
                          onChange={(e) =>
                            setYearlyIncome(Number(e.target.value))
                          }
                        />
                        <InputGroup.Text id="inputGroup-sizing-sm">
                          ₹{yearlyIncome}
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                  </div>
                  <div className="slider_div">
                    <Slider
                      aria-label="Custom marks"
                      getAriaValueText={valuetext}
                      min={0}
                      max={500000}
                      valueLabelDisplay="auto"
                      marks={yearlyIncomemark}
                      value={yearlyIncome}
                      onChange={(e, value) => setYearlyIncome(value)}
                    />
                    {/* <input type='range'/> */}
                  </div>
                </div>

                <div className="slider_main_div">
                  <div className="top_part_div">
                    <div className="left_side_div">
                      <p className="text">Existing Loan EMI</p>
                    </div>
                    <div className="right_side_div">
                      <InputGroup size="sm">
                        <Form.Control
                          value={existingEMI}
                          aria-label="Small"
                          type="type"
                          aria-describedby="inputGroup-sizing-sm"
                          onChange={(e) =>
                            setExistingEMI(Number(e.target.value))
                          }
                        />
                        <InputGroup.Text id="inputGroup-sizing-sm">
                          ₹{existingEMI}
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                  </div>
                  <div className="slider_div">
                    <Slider
                      value={existingEMI}
                      aria-label="Custom marks"
                      defaultValue={20}
                      step={10}
                      min={0}
                      max={50000}
                      valueLabelDisplay="auto"
                      marks={exstingIncomemark}
                      onChange={(e, value) => setExistingEMI(value)}
                    />
                  </div>
                </div>

                <div className="slider_main_div">
                  <div className="top_part_div">
                    <div className="left_side_div">
                      <p className="text">Loan Tenure</p>
                    </div>
                    <div className="right_side_div">
                      <InputGroup size="sm">
                        <Form.Control
                          value={loanTenure}
                          aria-label="Small"
                          type="type"
                          aria-describedby="inputGroup-sizing-sm"
                          onChange={(e) =>
                            setLoanTenure(Number(e.target.value))
                          }
                        />
                        <InputGroup.Text id="inputGroup-sizing-sm">
                          Yrs {loanTenure}
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                  </div>
                  <div className="slider_div">
                    <Slider
                      value={loanTenure}
                      aria-label="Custom marks"
                      //   defaultValue={20}
                      step={5}
                      valueLabelDisplay="auto"
                      min={0}
                      max={30}
                      marks={yearMarks}
                      onChange={(e, value) => setLoanTenure(value)}
                    />
                  </div>
                </div>

                <div className="slider_main_div">
                  <div className="top_part_div">
                    <div className="left_side_div">
                      <p className="text">Rate of Interest</p>
                    </div>
                    <div className="right_side_div">
                      <InputGroup size="sm">
                        <Form.Control
                          value={interestRate}
                          aria-label="Small"
                          type="type"
                          aria-describedby="inputGroup-sizing-sm"
                          onChange={(e, value) => setInterestRate(value)}
                        />
                        <InputGroup.Text id="inputGroup-sizing-sm">
                          % {interestRate}
                        </InputGroup.Text>
                      </InputGroup>
                    </div>
                  </div>
                  <div className="slider_div">
                    <Slider
                      value={interestRate}
                      aria-label="Custom marks"
                      defaultValue={20}
                      step={10}
                      valueLabelDisplay="auto"
                      marks={rateInterestMark}
                      onChange={(e, value) => setInterestRate(value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="emi_card_holder">
                <div className="top_heading">
                  <p className="text_head">Your Monthly EMI</p>
                  <p className="amount_text">₹ {emi}</p>
                </div>

                <div className="intrest_main_div">
                  <div className="label_div">
                    <p className="label">Loan Amount</p>
                  </div>

                  <div className="value_div">
                    <p className="value_text">₹ {loanAmount}</p>
                  </div>
                </div>

                <div className="intrest_main_div">
                  <div className="label_div">
                    <p className="label">Interest at {interestRate}% p.a.</p>
                  </div>

                  <div className="value_div">
                    <p className="value_text">₹{totalInterestPayable}</p>
                  </div>
                </div>

                <div className="total_main_div">
                  <div className="label_div">
                    <p className="label">Total Payable</p>
                  </div>

                  <div className="value_div">
                    <p className="value_text">₹{totalPayable}</p>
                  </div>
                </div>

                <div className="card_footer">
                  <div className="lottie_holder">
                    <Weighing_Lottie />
                  </div>

                  {props.navigate ? (
                    <div className="btn_holder">
                      <RedRoundBtn
                        btn_name="Check Eligibility"
                        // onClick={() => calculateLoan()}
                        onClick={() => navigate(props.navigate)}
                      />
                    </div>
                  ) : !showReset ? (
                    <div className="btn_holder">
                      <RedRoundBtn
                        btn_name="Check Eligibility"
                        onClick={() => calculateLoan()}
                        // onClick={() => setShowReset(true)}
                      />
                    </div>
                  ) : (
                    <div className="btn_holder">
                      <RedRoundBtn
                        btn_name="Reset"
                        onClick={() => setShowReset(false)}
                      />
                    </div>
                  )}

                  {/* {props.navigate ? (
                    <div className="btn_holder">
                      <RedRoundBtn
                        btn_name="Check Eligibility"
                        onClick={() => navigate(props.navigate)}
                      />
                    </div>
                  ) : !showReset ? (
                    <div className="btn_holder">
                      <RedRoundBtn
                        btn_name="Check Eligibility"
                        onClick={() => setShowReset(true)}
                      />
                    </div>
                  ) : (
                    <div className="btn_holder">
                      <RedRoundBtn
                        btn_name="Reset"
                        onClick={() => setShowReset(false)}
                      />
                    </div>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Calculate_Personal_Loan_Emi;
